const LOCATION_TYPES = [
  "Freizeitfläche",
  "Eventlocation",
  "Hotel",
  "Resort",
  "Touristischer Betrieb",
  "Immobilienfläche",
  "Bestehender Betreiber",
  "Sonstiges",
];

const CURRENT_STATUS_OPTIONS = [
  "Leer",
  "In Nutzung",
  "Umbau geplant",
  "Bestehender Freizeitbetrieb",
  "Hotelbetrieb",
  "Sonstiges",
];

const PRODUCT_OPTIONS = ["PVRA", "AR_ENA", "PINE VR", "Hotel VR", "PINE Places"];

function Select({ label, name, value, onChange, options, testId, placeholder = "Bitte wählen" }) {
  return (
    <div>
      <label className="field-label">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="field"
        data-testid={testId}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
    </div>
  );
}

function Input({ label, name, value, onChange, placeholder, testId }) {
  return (
    <div>
      <label className="field-label">{label}</label>
      <input
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="field"
        placeholder={placeholder}
        data-testid={testId}
      />
    </div>
  );
}

export default function LeadFormStandortFields({ data, set }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <Select
        label="Standorttyp"
        name="location_type"
        value={data.location_type}
        onChange={set}
        options={LOCATION_TYPES}
        testId="select-location-type"
      />
      <Input
        label="Ort / Region"
        name="city_region"
        value={data.city_region}
        onChange={set}
        testId="input-region"
      />
      <Input
        label="Verfügbare Fläche (m²)"
        name="available_area"
        value={data.available_area}
        onChange={set}
        placeholder="z. B. 250"
        testId="input-area"
      />
      <Input
        label="Raumhöhe (optional)"
        name="ceiling_height"
        value={data.ceiling_height}
        onChange={set}
        placeholder="z. B. 3.5 m"
        testId="input-ceiling"
      />
      <Select
        label="Aktueller Zustand"
        name="current_status"
        value={data.current_status}
        onChange={set}
        options={CURRENT_STATUS_OPTIONS}
        testId="select-current-status"
      />
      <Select
        label="Interessantes System"
        name="product_interest"
        value={data.product_interest}
        onChange={set}
        options={PRODUCT_OPTIONS}
        testId="select-product-interest"
        placeholder="Noch unklar"
      />
    </div>
  );
}
